import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addPersonData,
  deletePeopleData,
  fetchPeopleList,
  updatePeopleList,
} from "../../apis/peopleList";


export const fetchPeopleListData = createAsyncThunk(
  "peopleList/fetchPeopleList",
  async (_, { rejectWithValue }) => {
    try {
      const peopleList = await fetchPeopleList();
      return peopleList;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.peopleList.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const updatePeopleListData = createAsyncThunk(
  "peopleList/updatePeopleList",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        personId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const peopleList = await updatePeopleList(id, data);
      return peopleList;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deletePeopleListData = createAsyncThunk(
  "peopleList/deletePeopleList",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deletePeopleData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewPersonData = createAsyncThunk(
  "peopleList/addPerson",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addPersonData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
